/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_F1_DescInputs */

const en_landing_features_f1_desc = /** @type {(inputs: Landing_Features_F1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The model is tuned for multi-turn editing. Each pass changes what you ask for and leaves the rest alone, so a fifth edit does not drift in colour, texture or position from the first.`)
};

const zh_landing_features_f1_desc = /** @type {(inputs: Landing_Features_F1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 4.5 专为多轮编辑调优。每一轮只改你要求的部分，其余保持不变，第五次修改也不会在颜色、纹理或位置上偏离第一次。`)
};

/**
* | output |
* | --- |
* | "The model is tuned for multi-turn editing. Each pass changes what you ask for and leaves the rest alone, so a fifth edit does not drift in colour, texture or..." |
*
* @param {Landing_Features_F1_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_features_f1_desc = /** @type {((inputs?: Landing_Features_F1_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_F1_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_features_f1_desc(inputs)
	return zh_landing_features_f1_desc(inputs)
});
export { landing_features_f1_desc as "landing.features.f1_desc" }